export const OpenVariable = Object.freeze({
  WHATSAPP_API_ENABLED: "WHATSAPP_API_ENABLED",
  OAUTH_LOGIN_ENABLED: "OAUTH_LOGIN_ENABLED",
  ROUTE_SEARCH_STYLE_ENABLED: "ROUTE_SEARCH_STYLE_ENABLED"
});
